define.alias("shared/utils/number-helpers/is-in-range", "settings/utils/number-helpers/is-in-range");